import React from 'react';
import {
  CHALLENGES_ROUTE_ACTIVE,
  CHALLENGES_ROUTE_UPCOMING,
  CHALLENGES_ROUTE_COMPLETED,
} from '@members/challenges/urls';
import { ChallengesCopy, useChallenges } from '@members/copy/copy.generated';
import { Challenges } from '@members/copy/models.generated/Challenges';
import LayoutNavbar from '@members/layout/nav/Navbar';
import MainLink from '@members/layout/nav/Navbar/MainLink';
import MainNavLinks from '@members/layout/nav/Navbar/MainNavLinks';

export const CHALLENGES_NAV_ID = 'challenges-nav';

const Navbar: React.FC<React.PropsWithChildren<unknown>> = () => {
  const label = useChallenges(Challenges.NavLabel);
  return (
    <LayoutNavbar id={CHALLENGES_NAV_ID} aria-label={label}>
      <MainNavLinks>
        <MainLink
          href={`/challenges${CHALLENGES_ROUTE_ACTIVE}`}
          data-test-id="activeChallengesLink"
        >
          <ChallengesCopy id={Challenges.Active} />
        </MainLink>
        <MainLink
          href={`/challenges${CHALLENGES_ROUTE_UPCOMING}`}
          data-test-id="upcomingChallengesLink"
        >
          <ChallengesCopy id={Challenges.Upcoming} />
        </MainLink>
        <MainLink
          href={`/challenges${CHALLENGES_ROUTE_COMPLETED}`}
          data-test-id="completedChallengesLink"
        >
          <ChallengesCopy id={Challenges.Completed} />
        </MainLink>
      </MainNavLinks>
    </LayoutNavbar>
  );
};

export default Navbar;
